import login from './login';
import aad_login from './aad_login';

export default {
  login,
  aad_login,
};
